export const state = {
    contactMessage: ''
}